import axios from "axios";
import { createApp } from "vue";
import "../public/app.css";
import App from "./App.vue";
import router from "./router";
import './registerServiceWorker'

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router).mount("#app");
